export type LatLng = { lat: number; lng: number };

export type TrackedLatest = {
  lat: number;
  lng: number;
  ts: number;
  battery?: number;
  speed?: number;
  accuracy?: number;
};

export type TrackedConfig = {
  name?: string;
  resp?: string;
  photo?: string;
  geofence?: { center: LatLng; radius: number };
  created?: string;
};

export type TrackedAlert = {
  ts: number;
  type: 'sos' | 'geofence_out' | 'geofence_in' | 'low_battery' | 'offline';
  message?: string;
  acknowledged?: boolean;
  ackBy?: string;
  ackTs?: number;
};

export type TrackedResident = {
  uid: string;
  config?: TrackedConfig;
  latest?: TrackedLatest;
  alerts?: Record<string, TrackedAlert>;
};

export type ResidentStatus = 'inside' | 'outside' | 'sos' | 'offline';

export const OFFLINE_THRESHOLD_MS = 5 * 60 * 1000;
